var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "377px",
    height: "293px",
    viewBox: "0 0 377 293",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MD / Vector / Data + Gears") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.192,288.355 L1.01,277.081 L0.829,10.918 L182.192,0.466 L182.192,288.355 L182.192,288.355 Z M12.9,257.974 L69.316,257.974 L69.316,214.729 L12.9,214.729 L12.9,257.974 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "22.1105408%",
    y1: "54.3143364%",
    x2: "78.1352005%",
    y2: "49.2505792%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "path-4",
    points: "0.692 265.502 173.836 266.585 173.836 0.189 0.692 1.118 0.692 265.502"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-6",
    points: "0.942 0.276 0.942 6.978 81.021 6.978 81.021 0.759 0.942 0.276"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-6.47110978%",
    y1: "50%",
    x2: "100.00025%",
    y2: "50%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "path-9",
    points: "0.942 0.016 0.942 4.266 82.341 4.266 82.341 0.326 0.942 0.016"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4.74575855%",
    y1: "50%",
    x2: "99.9990172%",
    y2: "50%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "path-12",
    points: "0.942 0.698 0.942 4.937 44.157 4.937 44.157 0.997 0.942 0.698"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-8.9390258%",
    y1: "49.9882048%",
    x2: "100.001388%",
    y2: "49.9882048%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-86.5711855%",
    y1: "-58.0464301%",
    x2: "367.243335%",
    y2: "-77.853912%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3ECEC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F4EC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.944,1.924 C0.944,2.44 1.363,2.859 1.88,2.859 C2.397,2.859 2.816,2.44 2.816,1.924 C2.816,1.406 2.397,0.987 1.88,0.987 C1.363,0.987 0.944,1.406 0.944,1.924",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100.037393%",
    y2: "50%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MD-/-Vector-/-Data-+-Gears",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(194.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.192,288.355 L1.01,277.081 L0.829,10.918 L182.192,0.466 L182.192,288.355 L182.192,288.355 Z M12.9,257.974 L69.316,257.974 L69.316,214.729 L12.9,214.729 L12.9,257.974 Z",
    id: "Fill-29",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(22.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-33"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-32",
    mask: "url(#mask-5)",
    points: "0.692 265.502 173.836 266.585 173.836 0.189 0.692 1.118 0.692 265.502"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-35",
    fill: "#5BBDB7",
    points: "288.493 258.057 274.779 258.057 275.318 212.032 290.112 212.032 288.493 258.057"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-36",
    fill: "#EE9E35",
    points: "311.19 258.057 296.396 258.057 294.237 189.021 311.19 189.021 311.19 258.057"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#E15A66",
    points: "317.309 258.057 332.102 258.057 332.102 201.349 317.309 201.349"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-38",
    fill: "#21837F",
    points: "332.102 258.057 317.309 258.057 317.309 201.349 333.721 201.349 332.102 258.057"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-39",
    fill: "#FACB57",
    points: "353.014 258.057 338.22 258.057 338.22 168.474 357.332 168.474 353.014 258.057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.36,47.801 C319.958,41.375 314.206,36.427 307.745,33.071 C307.934,38.436 306.296,43.745 301.945,47.287 C305.746,49.493 309.129,52.555 311.777,56.421 C316.228,62.917 317.82,70.524 316.837,77.756 C317.676,77.372 318.564,77.095 319.503,76.926 C320.1,76.898 320.697,76.87 321.295,76.842 C322.007,75.831 322.693,74.802 323.338,73.744 C323.769,73.038 324.211,71.717 324.807,71.105 L324.865,71.042 C325.035,70.69 325.206,70.338 325.374,69.985 C326.74,67.116 329.426,69.242 331.932,68.061 C330.623,57.694 327.772,52.783 324.36,47.801",
    id: "Fill-40",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.837,113.495 C280.963,113.495 281.087,113.501 281.212,113.507 L281.227,113.499 C281.043,112.563 280.83,111.633 280.571,110.702 C280.461,110.306 280.34,109.913 280.228,109.517 L280.196,109.409 C279.847,108.296 279.498,107.183 279.153,106.069 C278.847,105.083 278.753,104.102 278.827,103.145 C273.184,101.659 267.941,98.563 263.862,93.986 C261.259,96.797 258.285,99.058 254.993,101.177 C253.83,101.926 252.632,102.506 251.423,102.905 C256.977,109.603 266.711,114.959 274.515,117.597 C276.802,115.352 277.552,113.495 280.837,113.495",
    id: "Fill-41",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.473,95.655 C264,94.238 262.647,92.653 261.447,90.901 C251.926,77.003 255.474,58.018 269.372,48.497 C280.523,40.857 294.944,41.638 305.13,49.42 L311.876,35.502 C295.804,25.045 278.534,25.284 260.752,35.914 C239.905,50.196 234.583,78.674 248.865,99.521 C250.053,101.256 251.345,102.876 252.717,104.393 L265.473,95.655",
    id: "Fill-42",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.932,68.061 L316.465,67.818 C318.828,80.417 313.032,93.645 301.19,100.162 C293.973,104.134 285.85,104.87 278.481,102.865 L274.515,117.597 C285.231,120.113 292.46,119.844 300.82,116.846 C306.314,114.875 311.413,111.945 315.866,108.172 C328.239,97.688 333.712,84.221 331.932,68.061",
    id: "Fill-43",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-44",
    fill: "#5BBDB7",
    points: "46.137 23.931 46.137 176.497 168.255 176.497 167.575 24.078 46.137 23.931"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-45",
    fill: "#21837F",
    points: "58.719 122.285 56.07 167.881 160.712 169.588 158.191 119.233 58.719 122.285"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-46",
    fill: "#FFFFFE",
    points: "317.07 159.303 319.637 162.558 283.359 183.973 274.947 173.387 229.43 198.31 229.43 204.471 273.721 179.519 282.207 190.197 322.62 166.341 325.254 169.682 333.022 155.479 317.07 159.303"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#005C5A",
    points: "46.137 35.115 167.624 35.115 167.624 23.931 46.137 23.931"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#FFFFFE",
    points: "152.341 32.451 164.322 32.451 164.322 27.389 152.341 27.389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.212,29.92 C142.212,31.052 143.13,31.969 144.262,31.969 C145.393,31.969 146.311,31.052 146.311,29.92 C146.311,28.789 145.393,27.871 144.262,27.871 C143.13,27.871 142.212,28.789 142.212,29.92",
    id: "Fill-49",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.927,29.92 C134.927,31.052 135.844,31.969 136.976,31.969 C138.107,31.969 139.024,31.052 139.024,29.92 C139.024,28.789 138.107,27.871 136.976,27.871 C135.844,27.871 134.927,28.789 134.927,29.92",
    id: "Fill-50",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-51",
    fill: "#FFFFFE",
    points: "50.772 31.969 91.501 31.969 91.501 27.389 50.772 27.389"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#5BBDB7",
    points: "52.097 31.692 53.634 31.692 53.634 28.052 52.097 28.052"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-55",
    transform: "translate(70.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-54"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-53",
    fill: "url(#linearGradient-8)",
    mask: "url(#mask-7)",
    points: "0.942 0.276 0.942 6.978 81.021 6.978 81.021 0.759 0.942 0.276"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-58",
    transform: "translate(70.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-57"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-56",
    fill: "url(#linearGradient-11)",
    mask: "url(#mask-10)",
    points: "0.942 0.016 0.942 4.266 82.341 4.266 82.341 0.326 0.942 0.016"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-61",
    transform: "translate(70.000000, 155.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-60"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-59",
    fill: "url(#linearGradient-14)",
    mask: "url(#mask-13)",
    points: "0.942 0.698 0.942 4.937 44.157 4.937 44.157 0.997 0.942 0.698"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-62",
    fill: "#5BBDB7",
    points: "350.157 20.818 369.148 20.818 369.148 18.729 350.157 18.729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-63",
    fill: "#5BBDB7",
    points: "350.157 24.997 369.148 24.997 369.148 22.908 350.157 22.908"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-64",
    fill: "#5BBDB7",
    points: "350.157 29.176 369.148 29.176 369.148 27.087 350.157 27.087"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-65",
    fill: "#5BBDB7",
    points: "350.157 33.355 369.148 33.355 369.148 31.266 350.157 31.266"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-66",
    fill: "#5BBDB7",
    points: "220.603 138.118 261.742 138.118 261.742 136.028 220.603 136.028"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-67",
    fill: "#5BBDB7",
    points: "220.603 142.297 261.742 142.297 261.742 140.208 220.603 140.208"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-68",
    fill: "#5BBDB7",
    points: "220.603 146.477 261.742 146.477 261.742 144.387 220.603 144.387"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-69",
    fill: "#5BBDB7",
    points: "220.603 150.655 261.742 150.655 261.742 148.566 220.603 148.566"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    fill: "#5BBDB7",
    points: "328.435 135.685 350.25 135.685 350.25 133.596 328.435 133.596"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-71",
    fill: "#5BBDB7",
    points: "328.435 139.864 350.25 139.864 350.25 137.774 328.435 137.774"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-72",
    fill: "#5BBDB7",
    points: "328.435 144.043 350.25 144.043 350.25 141.954 328.435 141.954"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-73",
    fill: "#5BBDB7",
    points: "328.435 148.223 350.25 148.223 350.25 146.133 328.435 146.133"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-74",
    fill: "#5BBDB7",
    points: "200.058 29.176 221.873 29.176 221.873 27.087 200.058 27.087"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-75",
    fill: "#5BBDB7",
    points: "200.058 33.355 221.873 33.355 221.873 31.266 200.058 31.266"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-76",
    fill: "#5BBDB7",
    points: "200.058 37.535 221.873 37.535 221.873 35.445 200.058 35.445"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-77",
    fill: "#5BBDB7",
    points: "200.058 41.714 221.873 41.714 221.873 39.625 200.058 39.625"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-95",
    fill: "#FFFFFE",
    points: "329.272 46.286 327.867 44.74 345.405 28.783 346.811 30.329 329.272 46.286"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-96",
    fill: "#FFFFFE",
    points: "244.921 133.509 243.29 132.202 258.11 113.694 259.741 115 244.921 133.509"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-97",
    fill: "#FFFFFE",
    points: "226.095 33.17 227.292 31.458 246.726 45.042 245.528 46.755 226.095 33.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-98",
    fill: "#FFFFFE",
    points: "315.917 113.429 317.429 111.986 333.806 129.133 332.294 130.576 315.917 113.429"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-99",
    fill: "url(#linearGradient-15)",
    points: "206.9 257.974 263.316 257.974 263.316 214.729 206.9 214.729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-101",
    fill: "#5BBDB7",
    points: "131.291 204.907 167.599 204.907 167.599 202.817 131.291 202.817"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-102",
    fill: "#5BBDB7",
    points: "131.291 209.086 167.599 209.086 167.599 206.997 131.291 206.997"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-103",
    fill: "#5BBDB7",
    points: "131.291 213.266 167.599 213.266 167.599 211.176 131.291 211.176"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-104",
    fill: "#5BBDB7",
    points: "131.291 217.444 167.599 217.444 167.599 215.355 131.291 215.355"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-109",
    fill: "#1B2441",
    points: "130.626 199.336 168.264 199.336 168.264 189.188 130.626 189.188"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-110",
    fill: "#FACB57",
    points: "46.137 196.514 55.102 196.514 55.102 187.549 46.137 187.549"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-111",
    fill: "#5BBDB7",
    points: "59.719 194.424 120.032 194.424 120.032 189.941 59.719 189.941"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-112",
    fill: "#1B2441",
    points: "46.137 209.836 55.102 209.836 55.102 200.872 46.137 200.872"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-113",
    fill: "#5BBDB7",
    points: "59.719 207.747 94.263 207.747 94.263 203.265 59.719 203.265"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-114",
    fill: "#21837F",
    points: "46.137 223.159 55.102 223.159 55.102 214.194 46.137 214.194"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-115",
    fill: "#5BBDB7",
    points: "59.719 221.069 104.014 221.069 104.014 216.587 59.719 216.587"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-116",
    fill: "#21837F",
    points: "203.339 88.522 212.303 88.522 212.303 79.558 203.339 79.558"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-117",
    fill: "#FFFFFE",
    points: "216.921 86.432 233.349 86.432 233.349 81.95 216.921 81.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-118",
    fill: "#1B2441",
    points: "203.339 101.844 212.303 101.844 212.303 92.88 203.339 92.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-119",
    fill: "#FFFFFE",
    points: "216.921 99.755 233.349 99.755 233.349 95.272 216.921 95.272"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-120",
    fill: "#5BBDB7",
    points: "203.339 115.167 212.303 115.167 212.303 106.203 203.339 106.203"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-121",
    fill: "#FFFFFE",
    points: "216.921 113.078 233.349 113.078 233.349 108.595 216.921 108.595"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-133",
    fill: "#FFFFFE",
    points: "142.493 110.146 74.873 110.146 74.873 42.526 73.25 42.526 73.25 111.769 142.493 111.769 142.493 110.146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.634,110.552 C77.634,112.451 76.095,113.989 74.196,113.989 C72.298,113.989 70.759,112.451 70.759,110.552 C70.759,108.654 72.298,107.115 74.196,107.115 C76.095,107.115 77.634,108.654 77.634,110.552",
    id: "Fill-134",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.57,88.643 C90.57,90.002 89.469,91.104 88.11,91.104 C86.751,91.104 85.649,90.002 85.649,88.643 C85.649,87.284 86.751,86.183 88.11,86.183 C89.469,86.183 90.57,87.284 90.57,88.643",
    id: "Fill-135",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.262,63.624 C144.262,64.982 143.159,66.084 141.801,66.084 C140.441,66.084 139.34,64.982 139.34,63.624 C139.34,62.265 140.441,61.163 141.801,61.163 C143.159,61.163 144.262,62.265 144.262,63.624",
    id: "Fill-136",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.282,99.327 C110.282,100.686 109.181,101.788 107.821,101.788 C106.462,101.788 105.361,100.686 105.361,99.327 C105.361,97.968 106.462,96.866 107.821,96.866 C109.181,96.866 110.282,97.968 110.282,99.327",
    id: "Fill-137",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-138",
    fill: "#FFFFFE",
    points: "73.94 112.196 72.56 111.342 87.706 86.86 107.728 98.836 141.902 62.526 143.084 63.639 108.015 100.899 88.245 89.074 73.94 112.196"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-145",
    fill: "#FFFFFE",
    points: "37.316 264.98 122.122 264.98 122.122 230.948 37.316 230.948"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-146",
    fill: "#5BBDB7",
    points: "217.211 236.352 253.52 236.352 253.52 234.262 217.211 234.262"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-147",
    fill: "#5BBDB7",
    points: "217.211 240.53 253.52 240.53 253.52 238.441 217.211 238.441"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-148",
    fill: "#5BBDB7",
    points: "217.211 244.71 253.52 244.71 253.52 242.62 217.211 242.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-149",
    fill: "#5BBDB7",
    points: "217.211 248.89 253.52 248.89 253.52 246.8 217.211 246.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-150",
    fill: "#5BBDB7",
    points: "217.211 231.128 253.52 231.128 253.52 223.781 217.211 223.781"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-151",
    fill: "#5BBDB7",
    points: "151.223 237.188 153.624 226.289 142.621 228.585 144.944 230.909 134.409 241.444 138.363 245.399 148.899 234.863 151.223 237.188"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-152",
    fill: "#1B2441",
    points: "137.936 259.672 144.017 259.672 144.017 249.188 137.936 249.188"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-153",
    fill: "#21837F",
    points: "146.584 259.672 152.666 259.672 152.666 243.469 146.584 243.469"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-154",
    fill: "#EE9E35",
    points: "155.162 259.672 161.73 259.672 161.73 235.845 155.162 235.845"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-155",
    fill: "#1B2441",
    points: "63.521 249.875 69.385 241.301 75.901 247.75 88.75 235.177 103.17 254.366 77.634 257.632 61.893 253.957 63.521 249.875"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-156",
    fill: "#EE9E35",
    points: "42.346 258.244 51.957 245.22 60.132 255.079 61.893 255.795 69.711 253.345 77.634 240.378 88.75 251.304 105.093 232.931 112.921 258.244 42.346 258.244"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-157",
    fill: "#21837F",
    points: "42.346 258.244 48.862 251.712 55.703 254.57 62.87 247.629 69.711 253.345 81.536 240.93 95.121 253.345 112.886 240.93 112.921 258.244 42.346 258.244"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-158",
    fill: "#F0AB85",
    points: "30.276 152.523 38.123 167.304 29.476 166.887 28.869 152.048 30.276 152.523"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-159",
    fill: "#FFFFFE",
    points: "17.954 145.975 25.202 145.964 28.206 192.813 15.217 192.813 17.954 145.975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.646,283.501 C4.646,283.501 2.855,284.909 3.184,286.704 C3.512,288.499 3.977,292.702 3.977,292.702 L5.819,292.702 L5.762,288.782 C5.768,288.525 9.712,292.702 10.38,292.702 L20.127,292.702 C20.127,292.702 20.775,290.058 15.051,289.208 C9.328,288.357 4.646,283.501 4.646,283.501",
    id: "Fill-160",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.871,281.712 L10.192,285.151 C10.518,286.096 11.151,286.897 11.992,287.436 C12.922,288.031 14.377,288.861 16.543,289.502 C13.894,291.763 9.679,289.401 7.268,287.731 C6.093,286.918 5.261,285.703 4.912,284.317 L4.359,281.712 L8.871,281.712",
    id: "Fill-161",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.214,283.501 C23.214,283.501 21.423,284.909 21.751,286.704 C22.08,288.499 22.545,292.702 22.545,292.702 L24.387,292.702 L24.33,288.782 C24.335,288.525 28.28,292.702 28.948,292.702 L38.695,292.702 C38.695,292.702 39.343,290.058 33.619,289.208 C27.896,288.357 23.214,283.501 23.214,283.501",
    id: "Fill-162",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.439,281.712 L28.76,285.151 C29.085,286.096 29.719,286.897 30.56,287.436 C31.489,288.031 32.945,288.861 35.11,289.502 C32.462,291.763 28.247,289.401 25.836,287.731 C24.661,286.918 23.829,285.703 23.479,284.317 L22.927,281.712 L27.439,281.712",
    id: "Fill-163",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.395,192.813 C12.395,192.813 11.177,199.815 18.18,234.232 C12.511,252.169 21.589,282.18 21.589,282.18 L28.206,282.18 L32.711,192.813 L12.395,192.813",
    id: "Fill-164",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.406,145.975 L26.757,202.816 L34.546,199.482 C34.546,199.482 31.037,188.812 31.37,173.988 C30.179,163.268 36.261,168.915 28.81,148.275 C26.035,145.964 24.406,145.975 24.406,145.975",
    id: "Fill-165",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.423,140.104 L24.511,144.896 C24.109,147.005 21.713,148.05 19.895,146.91 L16.698,144.906 L22.406,132.004 L25.423,140.104",
    id: "Fill-166",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.027,192.813 C6.027,192.813 -2.643,199.815 4.36,234.232 C-1.309,252.169 3.693,282.18 3.693,282.18 L9.633,282.18 L26.343,192.813 L6.027,192.813",
    id: "Fill-167",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.954,141.157 C17.954,141.157 10.636,145.271 8.361,148.942 C6.194,152.442 5.444,160.407 5.235,167.499 C4.949,177.236 0.247,202.816 0.247,202.816 L19.864,202.816 L20.353,147.129 L17.954,141.157",
    id: "Fill-168",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.396,125.728 C27.958,124.603 23.691,129.151 23.691,129.151 L20.353,147.129 L15.22,139.218 C15.22,139.218 14.927,128.468 19.889,121.349 C23.442,117.038 30.262,118.275 33.71,122.468 C35.388,124.507 35.737,127.322 35.575,129.913 C35.357,133.391 34.371,153.354 34.371,153.354 L24.207,145.825 C24.207,145.825 24.451,143.795 25.423,140.104 C27.097,133.751 35.375,126.482 32.396,125.728",
    id: "Fill-169",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.362,128.876 C23.018,128.61 23.866,129.053 24.256,129.864 C24.646,130.676 24.431,131.55 23.775,131.816 C23.12,132.082 22.272,131.64 21.882,130.828 C21.492,130.017 21.707,129.143 22.362,128.876",
    id: "Fill-170",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.124,140.946 C27.948,141.25 28.757,141.421 29.294,141.228 C33.153,138.431 34.546,127.26 34.546,127.26 L31.49,124.013 L25.405,125.351 L22.406,132.004 C21.605,133.78 21.698,135.831 22.655,137.527 C23.792,139.066 25.329,140.285 27.124,140.946",
    id: "Fill-171",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.413,125.495 C33.096,128.875 23.691,129.151 23.691,129.151 L23.201,124.577 L28.684,121.559 L33.024,124.17 C33.024,124.17 33.462,124.931 33.413,125.495",
    id: "Fill-172",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.208,126.151 C32.895,127.409 34.169,129.601 34.169,129.601 L34.917,128.249 L34.896,127.078 L34.158,126.165 C34.158,126.165 33.52,124.894 33.208,126.151",
    id: "Fill-173",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.362,148.942 C0.87,150.05 5.354,174.538 7.393,184.592 C7.895,187.066 10.425,188.576 12.833,187.817 C21.092,185.212 33.158,174.396 33.158,174.396 L31.246,171.987 L15.217,175.729 C15.217,175.729 21.366,147.658 10.362,148.942",
    id: "Fill-174",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.353,166.237 L26.253,185.423 C26.163,185.979 26.592,186.482 27.155,186.482 L39.427,186.482 C39.876,186.482 40.259,186.155 40.329,185.712 L43.374,166.526 C43.462,165.972 43.033,165.47 42.471,165.47 L30.254,165.47 C29.806,165.47 29.424,165.795 29.353,166.237",
    id: "Fill-175",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.973,174.731 C43.048,174.058 42.984,173.635 42.759,172.239 C42.466,170.425 42.543,167.582 40.689,168.999 C38.938,171.196 38.735,173.532 38.735,173.532 C38.378,174.821 39.167,176.612 39.904,177.584 L41.179,180.36 C41.179,180.36 43.378,177.801 42.973,174.731",
    id: "Fill-176",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-179",
    transform: "translate(34.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.944,1.924 C0.944,2.44 1.363,2.859 1.88,2.859 C2.397,2.859 2.816,2.44 2.816,1.924 C2.816,1.406 2.397,0.987 1.88,0.987 C1.363,0.987 0.944,1.406 0.944,1.924",
    id: "Fill-177",
    fill: "url(#linearGradient-18)",
    mask: "url(#mask-17)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.652,286.6 C212.652,286.6 210.121,288.947 204.349,290.418 C203.078,290.741 201.708,290.309 201.708,292.405 C204.403,292.405 208.713,292.405 208.713,292.405 L214.538,291.397 L214.538,292.405 L217.686,292.405 C217.686,292.405 218.562,287.26 216.724,286.6 C215.021,286.6 212.652,286.6 212.652,286.6",
    id: "Fill-180",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.007,282.903 L212.652,286.6 C213.801,287.396 215.309,287.445 216.508,286.729 L216.724,286.6 L217.377,282.903 L213.007,282.903",
    id: "Fill-181",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.021,286.6 C238.021,286.6 235.49,288.947 229.718,290.418 C228.447,290.741 227.077,290.309 227.077,292.405 C229.772,292.405 234.082,292.405 234.082,292.405 L239.907,291.397 L239.907,292.405 L243.055,292.405 C243.055,292.405 243.931,287.26 242.093,286.6 C240.391,286.6 238.021,286.6 238.021,286.6",
    id: "Fill-182",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.376,282.903 L238.021,286.6 C239.17,287.396 240.678,287.445 241.877,286.729 L242.093,286.6 L242.746,282.903 L238.376,282.903",
    id: "Fill-183",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.118,146.216 C174.728,146.327 173.359,146.577 170.741,145.654 C168.393,144.825 164.063,141.578 163.893,144.382 C165.485,146.617 167.089,149.453 167.089,149.453 C168.185,150.7 170.918,151.173 172.691,151.126 L178.157,150.299 C178.157,150.299 179.675,147.932 179.766,147.833 L178.992,146.973 C177.651,146.938 176.347,146.67 175.118,146.216",
    id: "Fill-184",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.86,146.926 C173.86,146.926 173.731,147.008 173.478,147.101 C173.719,147.366 173.941,147.644 174.154,147.927 C175.321,148.5 176.469,149.112 177.629,149.699 C177.889,148.937 178.255,147.867 178.294,147.796 L171.505,142.336 C171.505,142.336 170.488,142.917 171.468,144.488 C172.448,146.061 173.86,146.926 173.86,146.926",
    id: "Fill-185",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-186",
    fill: "#EC967C",
    points: "227.835 126.175 227.1 133.409 234.853 133.717 233.299 122.501 227.835 126.175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.453,127.497 C224.553,127.472 223.718,127.337 223.281,126.981 C220.684,123.203 223.643,113.02 223.643,113.02 L227.795,111.271 L233.07,114.562 L233.37,121.387 C233.45,123.208 232.576,124.956 231.015,126.094 C229.344,127.032 227.415,127.551 225.453,127.497",
    id: "Fill-187",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.239,118.43 C231.949,117.283 232.101,114.638 230.933,114.829 C230.081,114.968 227.163,115.089 226.182,115.089 C223.842,115.089 219.67,114.173 219.67,110.612 C219.67,108.832 221.396,107.297 222.49,106.84 C223.564,106.393 224.776,106.414 225.874,106.798 C228.451,107.698 231.869,109.686 233.231,109.412 C235.524,108.951 237.812,110.295 237.779,112.244 C237.745,114.325 236.659,117.455 235.636,119.443 C235.044,120.594 234.253,121.626 233.299,122.501 L232.239,118.43",
    id: "Fill-188",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.611,118.688 C234.09,118.227 233.113,118.313 232.432,118.882 C231.749,119.45 231.618,120.284 232.14,120.744 C232.661,121.205 233.637,121.118 234.319,120.55 C235.002,119.981 235.133,119.147 234.611,118.688",
    id: "Fill-189",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.415,136.666 C205.806,148.024 177.473,145.021 177.473,145.021 L176.163,152.448 C176.163,152.448 212.111,163.07 216.595,154.571 C221.079,146.073 235.024,125.308 220.415,136.666",
    id: "Fill-190",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.977,131.31 C230.711,131.31 230.449,131.314 230.192,131.324 C221.643,131.638 214.965,143.436 214.965,151.99 L214.965,182.932 L247.964,182.932 L247.964,147.521 C247.964,139.651 242.327,132.771 234.549,131.575 C233.44,131.404 232.251,131.31 230.977,131.31",
    id: "Fill-191",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.45,176.942 L213.147,177.782 C210.161,177.896 207.768,173.646 206.965,170.394 C206.845,169.905 207.295,169.467 207.783,169.586 C210.348,170.215 216.946,171.878 218.694,172.748 L220.45,176.942",
    id: "Fill-192",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.023,139.794 C246.023,139.794 262.666,162.021 252.211,172.804 C241.756,183.585 218.232,179.011 218.232,179.011 L218.232,172.149 C218.232,172.149 240.449,172.204 241.756,164.662 C243.063,157.121 236.473,148.953 236.473,148.953",
    id: "Fill-193",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.964,175.659 C237.432,181.726 220.85,179.135 218.559,178.738 L218.559,172.476 C221.442,172.452 240.812,172.021 242.077,164.719 C243.395,157.118 237,149.086 236.727,148.748 L236.219,149.158 C236.283,149.238 242.701,157.295 241.435,164.606 C240.195,171.755 218.675,171.823 218.237,171.823 L218.232,171.823 L217.905,171.822 L217.905,179.28 L218.17,179.332 C218.277,179.353 223.174,180.274 229.472,180.274 C235.336,180.274 242.407,179.465 247.964,176.395 L247.964,175.659",
    id: "Fill-194",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.965,182.932 C211.192,201.233 210.613,220.931 210.527,237.464 C210.39,264.095 212.575,283.557 212.575,283.557 L218.021,283.557 L229.391,207.431 C229.391,207.431 230.63,218.752 232.309,237.949 C233.625,253.013 234.246,265.747 237.784,283.557 C243.263,283.557 243.247,283.557 243.247,283.557 C243.247,283.557 247.964,228.589 247.964,182.932 C235.17,182.932 221.546,182.932 214.965,182.932",
    id: "Fill-195",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-196",
    fill: "#FFFFFE",
    points: "227.445 129.356 234.339 129.356 235.437 131.895 226.559 131.895 227.445 129.356"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTest);
export default __webpack_public_path__ + "static/media/card-test.16a5818200164dddb6c0b2710a36468e.svg";
export { ForwardRef as ReactComponent };